module.exports = __webpack_public_path__ + "src/img/eye.fa170e91.svg";